<template>
  <!-- <Navigation /> -->
  <!-- <router-link to="/">Home</router-link> |
    <router-link to="/about">About</router-link> |
    <router-link to="/test">Test</router-link> -->
  <router-view />
</template>

<script>
// @ is an alias to /src
// import Navigation from "@/components/Navigation.vue";

export default {
  name: "Home",
  components: {
    // Navigation,
  },
};
</script>

<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
}
</style>
